// strings.js

const strings = {
    STRIPE_DEV_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/test_00g8xz28R8BH6qs8xE", // vp
    STRIPE_PROD_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/dR68xp0t02t8aZ28xE", // vp

    STRIPE_SUBSCRIPTION_MANAGEMENT_URL: "https://billing.stripe.com/p/login/28ocP200L31J9gs7ss",
    SUBSCRIPTION_STATUS_API_URL: "https://funquiz.app/modular2/subscription-status",
    
    GENERIC_PAGE_TITLE: "VR Art Gen Ai 🎨",
    HOME_PAGE_TITLE: "Home - VR Art Gen Ai 🎨",
    DASHBOARD_PAGE_TITLE: "Home - VR Art Gen Ai 🎨",
    WELCOME_MESSAGE_H1_TITLE: "Welcome to VR Art Gen Ai 🎨",
    FX_DESCRIPTION_MESSAGE: "This f(x) can be used to generate VR style art, enter a prompt and then press the 'Submit Input' button below to get your result!",
    
    MAIN_API_NAME: "vision_p_gen_ai_1",
    MAIN_API_URL: "https://funquiz.app/modular2/vision-p-gen-ai-1",

    PROD_CLERK_PUB_KEY: "pk_live_Y2xlcmsueW9sbGVnLmNvbSQ",
    DEV_CLERK_PUB_KEY: "pk_test_aGFybWxlc3MtYmVlLTY5LmNsZXJrLmFjY291bnRzLmRldiQ",

    // ... add more strings as needed
};



export default strings;